import React from 'react';

import LivePlayerContainer from 'newDesign/modules/live/components/livePlayer/livePlayerContainer/LivePlayerContainer';

export const WorldLottery = () => (
  <LivePlayerContainer useFullScreen />
);

export default WorldLottery;
